import React from "react";
import { isMobile } from "react-device-detect";
import useTransitionStore from "../../../state/transitions";
import useCustomizerStore from "../../../state/customizer";

const PowertrainUI = () => {
  const model = useCustomizerStore((state) => state.model);
  const DisplayMode = useTransitionStore((state) => state.DisplayMode);

  return (
    <>
      {DisplayMode == "powertrain" && (
        <div
          style={{
            position: "absolute",
            right: isMobile ? null : "5%",
            left: isMobile ? "18px" : null,
            bottom: isMobile ? "2rem" : "2rem",
            color: "white",
            zIndex: "9999",
            fontSize: isMobile ? "12px" : "16px",
            textAlign: isMobile ? "left" : "right",
            margin: isMobile ? "0 8px 0px 0" : "0 8px 32px 0",
          }}
        >
          <div>
            {model == 2 ? "HYBRID MAX" : "4TH GENERATION TOYOTA HYBRID SYSTEM"}
          </div>
          <div>
            {model == 2
              ? "MPG 29/32/30 (City/Hwy/Combined)"
              : "MPG 42/41/41 (City/Hwy/Combined)"}
          </div>
        </div>
      )}
    </>
  );
};

export default PowertrainUI;
